import { RoutesPaths } from "../../../../constants/routes.ts"

export const LEAD_SOURCES_PATH = RoutesPaths.lead.leadSources

export const INBOX_TAB = "inbox"

export const INBOX_TAB_PATH = `${RoutesPaths.lead.list}?tab=${INBOX_TAB}`

export const INBOX_ITEM_PARAM = "item"

export const inboxItemPath = (id: string) =>
  `${INBOX_TAB_PATH}&${INBOX_ITEM_PARAM}=${encodeURIComponent(id)}`

/** Read once by the inbox: the Smart Filter to open with, then dropped from the address. */
export const INBOX_VIEW_PARAM = "view"

export const NEEDS_REVIEW_VIEW = "needs_review"

export const NEEDS_REVIEW_PATH = `${INBOX_TAB_PATH}&${INBOX_VIEW_PARAM}=${NEEDS_REVIEW_VIEW}`

export const inboxReviewPath = (id: string) =>
  RoutesPaths.lead.inboxReview(encodeURIComponent(id))
